import React, { useEffect, useRef, useState } from 'react';
import styles from './style/tem-item.module.less';
import { Input, Message } from '@arco-design/web-react';
import IconBtn from "../../components/IconBtn";
import {
    IconEdit, IconCopy, IconCheck, IconSuccessTip, IconErrorTip
} from "@arco-iconbox/react-aidb-v2";
import BorderBtn from "../../components/BorderBtn";
import copy from 'copy-to-clipboard'
import IconAdd from '@/assets/imgs/i-add.svg'
import { saveDocument } from '@/model/reference';
import { events } from '@/helpers/event-emitter';
import { ACTIONS } from '@/share/constants';
const TextArea = Input.TextArea;

function TemItem(props) {
    const { content, showBotButtons } = props;

    const [inputContent, setInputContent] = useState(content);
    const textareaRef = useRef(null);

    // 使用 useEffect 实现在 content 发生变化时更新 inputContent 的值
    React.useEffect(() => {
        setInputContent(content);
    }, [content]);

    function inputChange(e) {
        setInputContent(e);
        if (textareaRef.current) {
            textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
        }
    }

    const [edit, setEdit] = React.useState(false);
    function copyContent(inputContent) {
        copy(inputContent)
        Message.success({
            icon: <IconSuccessTip useCurrentColor={false} />,
            content: '复制成功',
        })
    }



    //添加文章到编辑器
    function handleAdd() {
        saveDocument({
            approvalStatus: 1,
            content: content.split('\n').filter(line => line.trim() !== '').map((line, index) => `<p>${line}</p>`).join(''),
            docStatus: 0,
            docType: 0,
            filePath: '/',
            fileType: 0,
            folderUuid: '',
            title: content.split('\n')[0],
            uuid: '',
            docVersionType: 1,
        }).then((res) => {
            if (res.data.success == true && res.data.data) {
                window.location.href = `/documentEdit?uuid=${res.data.data}&title=${content.split('\n')[0]}`
            } else {
                Message.error({
                    icon: <IconErrorTip useCurrentColor={false} />,
                    content: '添加失败，请重新尝试',
                })
            }
        }).catch(() => {
            Message.error({
                icon: <IconErrorTip useCurrentColor={false} />,
                content: '添加失败，请重新尝试',
            })
        })
    }
    return (
        <div className={styles.item}>
            <div className={`${styles.input} ${edit ? styles.edit : ''}`}>
                <Input.TextArea
                    autoSize
                    ref={textareaRef}
                    className={'g-input'}
                    disabled={!edit}
                    // maxLength={9999}
                    onChange={(e) => {
                        inputChange(e);
                    }}
                    value={inputContent}
                />
            </div>
            {showBotButtons ? (
                <div className={styles.bot}>
                    <div className={styles.count}>
                        {inputContent.length} 字
                    </div>
                    {
                        !edit &&
                        <div className={styles.btn} >
                            <IconBtn text={'添加到编辑器'} iconLeft={<IconAdd />} onClick={handleAdd} />
                            <IconBtn
                                text={'编辑'}
                                onClick={() => {
                                    setEdit(true);
                                }}
                                iconLeft={<IconEdit />}
                            />
                            <IconBtn text={'复制'} iconLeft={<IconCopy />} onClick={() => copyContent(inputContent)} />
                        </div>
                    }
                    {
                        edit &&
                        <div className={styles.btn}>
                            <BorderBtn
                                gradient={true}
                                text={'确定'}
                                onClick={() => {
                                    setEdit(false);
                                }}
                                iconLeft={<IconCheck />}
                            />
                        </div>
                    }
                </div>
            ) : ''}
        </div>
    );
}

export default TemItem;
